import { DOCUMENT } from '@angular/common';
import { HttpErrorResponse, HttpEvent, HttpEventType, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { GlobalAlertService, LoaderService, LoginRedirectService } from '@services';

export function errorInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const terminateLoader = inject(LoaderService).terminate;
  const endLoader = inject(LoaderService).end;
  const toLogin = inject(LoginRedirectService).goToLogin;
  const alertError = inject(GlobalAlertService).setError;
  const document = inject(DOCUMENT);

  let lastResponse: HttpEvent<unknown>;
  let error: unknown;

  return next(req).pipe(
    map(event => {
      lastResponse = event;
      return event;
    }),
    catchError((err: unknown) => {
      error = err;
      terminateLoader();
      // @ts-expect-error should be expected message property
      if (err?.message.toString().includes('i18n')) {
        return EMPTY;
      }
      if (!(err instanceof HttpErrorResponse)) {
        return throwError(() => new Error(err?.toString()));
      }
      switch (err.status) {
        case 401:
          toLogin();
          break;
        case 403:
          redirectToForbidden(document);
          break;
      }

      const errorMessage = err.message ? err.message : `${err.error.name}: ${err.error.message}`;
      alertError(errorMessage);
      return throwError(() => new Error(errorMessage));
    }),
    finalize(() => {
      if (lastResponse.type === HttpEventType.Sent && !error) {
        // last response type was 0, and we haven't received an error
        endLoader();
      }
    }),
  );
}

function redirectToForbidden(document: Document): void {
  const forbiddenPath = 'forbidden/index.html';
  document.location.href = `${document.location.origin}/${forbiddenPath}?type=forbidden`;
}
